export const statusRowContentFinished = (scoreHome, scoreGuest) => `        
<div class="score"><span class="host-score">${scoreHome}</span> - <span class="guest-score">${scoreGuest}</span></div>
<div class="status label minor-info">приключил</div> 
`